import type { Octokit } from '@octokit/rest';
import type { Codespace } from '../types';
import type { RepoRef } from '../utils/entityRepoRef';
import { type GitHubCodespace, mapToCodespace } from './codespaceMapper';

export async function fetchCodespaces(octokit: Octokit): Promise<Codespace[]> {
  const { data } = await octokit.rest.codespaces.listForAuthenticatedUser({
    per_page: 100,
  });

  return mapCodespaces(data.codespaces ?? []);
}

export async function fetchRepositoryCodespaces(
  octokit: Octokit,
  repoRef: RepoRef,
): Promise<Codespace[]> {
  const { data } = await octokit.rest.codespaces.listInRepositoryForAuthenticatedUser({
    owner: repoRef.owner,
    repo: repoRef.repo,
    per_page: 100,
  });

  return mapCodespaces(data.codespaces ?? []);
}

function mapCodespaces(codespaces: GitHubCodespace[]): Codespace[] {
  return codespaces
    .filter(cs => Boolean(cs.name && cs.web_url))
    .sort((a, b) => (b.last_used_at ?? '').localeCompare(a.last_used_at ?? ''))
    .map(cs => mapToCodespace(cs));
}
